export default {
  login: ({ commit }, userInfo) => {
    const { user_email: email, user_name: name, member_type: memberType, phone } = userInfo;

    commit('SET_EMAIL', email);
    commit('SET_NAME', name);
    commit('SET_PHONE', phone);
    commit('SET_MEMBER_TYPE', memberType);
    commit('SET_LOGGED', true);
  },

  ssoLogin: ({ commit }, userInfo) => {
    const { userId, name, memberType, phone } = userInfo;

    commit('SET_EMAIL', userId);
    commit('SET_NAME', name);
    commit('SET_PHONE', phone);
    commit('SET_MEMBER_TYPE', memberType);
    commit('SET_LOGGED', true);
  },

  updateUserId: ({ commit }, { userId }) => {
    commit('SET_USER_ID', userId);
  },

  updatePhone: ({ commit }, { phone }) => {
    commit('SET_PHONE', phone);
  },

  logout: ({ commit }) => {
    commit('SET_USER_ID', '');
    commit('SET_EMAIL', '');
    commit('SET_NAME', '');
    commit('SET_PHONE', '');
    commit('SET_MEMBER_TYPE', '');
    commit('SET_LOGGED', false);
  },
};
